import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD,
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_BY_ID,

    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE,

    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE,

    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE,

    ITrialInstitutionItemTemplateCategoryLoadAction,
    ITrialInstitutionItemTemplateCategoryLoadByIdAction,
    ITrialInstitutionItemTemplateCategoryLoadFailureAction,
    ITrialInstitutionItemTemplateCategoryLoadSuccessAction,

    ITrialInstitutionItemTemplateCategorySaveAction,
    ITrialInstitutionItemTemplateCategorySaveSuccessAction,
    ITrialInstitutionItemTemplateCategorySaveFailureAction,

    ITrialInstitutionItemTemplateCategoryCreateAction,
    ITrialInstitutionItemTemplateCategoryCreateSuccessAction,
    ITrialInstitutionItemTemplateCategoryCreateFailureAction,

    ITrialInstitutionItemTemplateCategoryValidateAction,
    ITrialInstitutionItemTemplateCategoryValidateSuccessAction,
    ITrialInstitutionItemTemplateCategoryValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialInstitutionItemTemplateCategories";
import { trialInstitutionItemTemplateCategoriesApi } from "../services/trialInstitutionItemTemplateCategories";


export const
    getTrialInstitutionItemTemplateCategoriesEpic = (action$): Observable<ITrialInstitutionItemTemplateCategoryLoadSuccessAction | ITrialInstitutionItemTemplateCategoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD)
            .mergeMap((_action: ITrialInstitutionItemTemplateCategoryLoadAction) => {
                return trialInstitutionItemTemplateCategoriesApi
                    .getTrialInstitutionItemTemplateCategories()
                    .map(response =>
                        LoadSuccess(response.trialInstitutionItemTemplateCategories, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionItemTemplateCategoryByIdEpic = (action$): Observable<ITrialInstitutionItemTemplateCategoryLoadSuccessAction | ITrialInstitutionItemTemplateCategoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_BY_ID)
            .mergeMap((action: ITrialInstitutionItemTemplateCategoryLoadByIdAction) => {
                return trialInstitutionItemTemplateCategoriesApi
                    .getTrialInstitutionItemTemplateCategoryById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionItemTemplateCategory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialInstitutionItemTemplateCategoryEpic = (action$): Observable<ITrialInstitutionItemTemplateCategorySaveSuccessAction | ITrialInstitutionItemTemplateCategorySaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE)
            .mergeMap((action: ITrialInstitutionItemTemplateCategorySaveAction) => {
                return trialInstitutionItemTemplateCategoriesApi
                    .setTrialInstitutionItemTemplateCategory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialInstitutionItemTemplateCategory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialInstitutionItemTemplateCategoryEpic = (action$): Observable<ITrialInstitutionItemTemplateCategoryCreateSuccessAction | ITrialInstitutionItemTemplateCategoryCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE)
            .mergeMap((_action: ITrialInstitutionItemTemplateCategoryCreateAction) => {
                return trialInstitutionItemTemplateCategoriesApi
                    .createTrialInstitutionItemTemplateCategory()
                    .map(response =>
                        CreateSuccess(
                            response.trialInstitutionItemTemplateCategory,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialInstitutionItemTemplateCategoryEpic = (action$): Observable<ITrialInstitutionItemTemplateCategoryValidateSuccessAction | ITrialInstitutionItemTemplateCategoryValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE)
            .mergeMap((action: ITrialInstitutionItemTemplateCategoryValidateAction) => {
                return trialInstitutionItemTemplateCategoriesApi
                    .validateTrialInstitutionItemTemplateCategory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialInstitutionItemTemplateCategory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



